import { render, staticRenderFns } from "./unassign-salesman-modal.vue?vue&type=template&id=44fdc22e"
import script from "./unassign-salesman-modal.vue?vue&type=script&lang=js"
export * from "./unassign-salesman-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports